import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import type { Role } from '@/api/types';
import { ROLE_DESCRIPTIONS, ROLE_LABELS } from '@/auth/roles';
import { useI18n } from '@/i18n/useI18n';
import { HOME_PATH } from '@/layout/nav';
import { Card, CardBody } from '@/ui/Card';

/**
 * 403 con explicación.
 *
 * Dice **qué rol hace falta y cuál tenés**. Un "no tenés permiso" a secas
 * termina en un ticket de soporte; con los dos roles en pantalla, la persona
 * ya sabe qué pedirle a su administrador.
 */
export function ForbiddenView({
  required,
  actual,
}: {
  required: Role;
  actual: Role | null;
}): ReactNode {
  const { t } = useI18n();

  return (
    <Card className="mx-auto max-w-xl">
      <CardBody className="space-y-3">
        <h1 className="text-lg font-semibold text-ink">{t('guard.forbidden.title')}</h1>
        <p className="text-sm text-ink-muted">
          {t('guard.forbidden.detail', {
            required: ROLE_LABELS[required],
            actual: actual === null ? '—' : ROLE_LABELS[actual],
          })}
        </p>
        <p className="text-sm text-ink-subtle">{ROLE_DESCRIPTIONS[required]}</p>
        <Link
          to={HOME_PATH}
          className="inline-block text-sm font-medium text-accent underline underline-offset-2"
        >
          {t('guard.forbidden.back')}
        </Link>
      </CardBody>
    </Card>
  );
}
